const locale = {
  consent: {
    title: () => "Privacy",
    description: () =>
      "I accept the Privacy Policy. I agree to the use of cookies for website traffic analysis.",
    accept: () => "Consent",
    close: () => "Close",
  },
  navbar: {
    pricing: () => "Pricing",
    hardware: () => "Hardware",
    contact: () => "Contact Us",
    menu: {
      possibilities: () => "Capabilities",
      cloud: () => "Rapidshop Cloud",
      kiosks: () => "Self-service Kiosks",
      pos: () => "POS App",
      kds: () => "Rapid KDS",
      discounts: () => "Promotions & Discounts",
      management: () => "Device Management",
      rapidshopAI: () => "Rapidshop AI",
      descriptions: {
        cloud: () =>
          "Your sales, profits, and orders in real-time. All in the Cloud, accessible from any device.",
        kiosks: () =>
          "Boost sales by up to 30%, cut costs, attract more Customers",
        pos: () =>
          "Ergonomic app for your waiters and staff. Interactive Customer Screen: e-Receipts, vouchers, always at your counter.",
        kds: () =>
          "Easy-to-use kitchen screen, connected to your printers to accelerate orders and streamline kitchen communication.",
        discounts: () => "Generate coupons, assign digital stamps",
        management: () => "Manage devices remotely or on-site",
        rapidshopAI: () =>
          "AI-powered management for your store, restaurant, or cafe. Meet the Virtual Customer Assistant at the Kiosk.",
      },
    },
  },
  landingPage: {
    firstSlide: {
      title: () => "Meet Rapidshop AI",
      subtitle: () => "AI finally at your point of sale!",
      description: () =>
        "This isn’t just an upgrade. It’s a revolution for your Customers and your business.",
      description2: () =>
        "Our kiosks interact with Customers just like a real person. With cutting-edge AI language models, our kiosks listen, answer, and suggest the right products, every time.",
    },
    hero: {
      autotype: {
        text1: () => "Increase your sales",
        text2: () => "Make your work easier",
        text3: () => "Enjoy more free time",
        text4: () => "Meet your new POS!",
      },
      subtitle: () =>
        "Rapidshop is a modern, AI-powered system for retail and restaurants. Sell more, work smarter.",
    },
    offer: {
      title: () => "Built from the ground up: ",
      subtitle: () => "A new ecosystem for your restaurant and retail",
      subtitle2: () => "Grow revenue, attract new Customers, ",
      subtitle3: () => "and turn new guests into loyal fans!",

      profit1: {
        title: () => "Clear & Powerful Dashboard",
        description: () =>
          "Remotely manage your business: live view of revenue, orders, and inventory – in real time.",
      },
      profit2: {
        title: () => "Modern, affordable hardware",
        description: () =>
          "Serve Customers and expand your business with future-proof devices. Offer promotions, sell in new places.",
      },
      profit3: {
        title: () => "POS Software",
        description: () =>
          "Seamlessly syncs with your venue and the Rapidshop Cloud. Works even when your internet drops.",
      },
      profit4: {
        title: () => "Artificial Intelligence",
        description: () =>
          "Unleash superpowers in your business! Let AI delight your Customers and help you manage smarter.",
      },
    },
    solution: {
      handheld: {
        title: () => "Rapidshop Handheld & Countertop Terminals",
        badge1: () => "Staff Support",
        badge2: () => "Faster Service",
        description1: () =>
          "Sleek, fast, and intuitive: Rapidshop terminals offer ergonomics, performance, and rock-solid reliability. We design software that guides your team, eliminating outdated, confusing procedures—so you spend less time on staff training.",
        description2: () =>
          "In short, these revolutionary, affordable units speed up ordering and payments. Your team stays in control, always knows what to upsell, and your bottom line grows.",
        description3: () =>
          "All terminals and kiosks work in one system, empowering you to handle orders in any context, effortlessly. Your Customers are happy—and you’re free to grow your business.",
        cta: () => "Learn more",
      },
      kiosk: {
        title: () => "Self-service kiosks with Voice AI agent option",
        badge1: () => "With AI Inside",
        badge2: () => "Boost Revenue",
        description1: () =>
          `Imagine <b>how many more Customers</b> you could have if they could order whenever inspiration strikes.`,
        description2: () =>
          `<b>See bigger orders</b> thanks to 24/7 recommendations and discounts. <b>And keep Customers coming back to an intuitive, engaging kiosk.</b>`,
        description3: () =>
          `Break language barriers—our Kiosk speaks multiple languages and will talk to your Customers in theirs. <b>No more lost sales due to complicated menus.</b> `,
        description4: () =>
          `Place your kiosk on a floor stand or discretely on your counter. Guests love the comfort of exploring your menu at their own pace and our smart sales features & eye-catching suggestions encourage them to buy more, more often.`,
        cta: () => "Learn more",
      },
      cloud: {
        title: () => "Rapidshop Cloud",
        badge1: () => "Live Sales Panel",
        badge2: () => "Smart Menu Builder",
        badge3: () => "Device Management",
        badge4: () => "Reports",
        description1: () =>
          `Your all-in-one command center. See live sales, trending menu items, and order details from every channel—kiosks, registers, tables, and delivery—all in one place, from any device.`,
        description2: () =>
          `Design your menu like an artist with our breakthrough editor. Organize, run in-menu promos, even add videos.`,
        description3: () =>
          `Manage devices directly from the panel: reboot kiosks, update menus, block or feature products, control printers and screens, all remotely.`,
        cta: () => "Learn more",
      },
      otherElements: {
        title: () => "Locators, pagers, kitchen screens (KDS), mobile apps…",
        title2: () => `Rapidshop offers more than you expect`,
        title3: () => "All in one system.",
        description: () =>
          `We want you to have everything you need, all in one solution. Not just POS with AI, but also locators, pagers, KDS screens, mobile apps, e-shops, and more.`,
        description2: () => "Even more innovations are on the way.",
        description3: () =>
          `Check out our subscription plans to find powerful new tools for retail and foodservice.`,
        seeOurSolutionLive: () =>
          "See how Rapidshop helps streamline sales at the Fenicja chain in Warsaw.",
        caseStudy: () => "Case study:",
      },
    },
    contactEndorsement: {
      title: () => "Start growing Your turnover today with us!",
      title2: () => "Let’s talk!",
      description: () =>
        `Leave your contact details. Your dedicated advisor will arrange a quick online meeting and show you <b>how new technology can boost your restaurant’s profits</b>.`,
      description2: () =>
        `Prefer an in-person visit? Our office is just steps from Warsaw Central Station. Test-drive Rapidshop yourself!`,
      description3: () =>
        `Prefer email? Drop us a line at: <a href="mailto:kontakt@rapidshop.pl">kontakt@rapidshop.pl</a>.`,
    },
    trust: {
      title: () => "Technology that moves with you",
      description1: () =>
        "Our system is built on cutting-edge technology, shaped by real-world experience in the restaurant industry. The result: stable, ergonomic solutions that feel natural to use from day one.",
      description2: () =>
        "We're driven by a relentless commitment to innovation and quality — so our clients always have the right tools to grow their business.",
      eventInfo: () => "Gastro Quick Service, Ptak Warsaw Expo, 2025",
      trustedBy: () => "Trusted by:",
      badges: {
        innovation: () => "Innovation",
        quality: () => "Quality",
        experience: () => "Experience",
      },
    },
    cards: {
      header: () => "Rapidshop is technology that lets you unlock",
      title: () => "the full potential of your business",
      whatYouGain: () => "WHAT'S IN IT FOR YOU?",
      cards: {
        card1: {
          title: () => "Cloud + POS",
          youSave1: () => "3 days a week",
          youSave2: () => "3 hours a day",
          youSave3: () => "3 team members",
          description: () =>
            "Manage your business from the cloud. Set prices, promotions, check reports, and manage staff and equipment from anywhere in the world.",
        },
        card2: {
          title: () => "Deposit system and KSeF support",
          youSave1: () => "regulatory compliance",
          youSave2: () => "time",
          description: () =>
            "Implement a POS perfect for today: compliant with KSeF and the deposit system. Apply deposits and packaging automatically along with products.",
        },
        card3: {
          title: () => "3-in-1 devices - POS, terminal, cash register",
          youSave1: () => "4 days per month",
          youSave2: () => "hundreds in service costs",
          youSave3: () => "staff",
          description: () =>
            "Build your restaurant on modern and cost-effective 3-in-1 equipment that, in addition to sales functions, offers payment terminal and fiscal cash register functions in one device. \n\nWith us, 3-in-1 is not only on small handheld sales devices - you can also have a Kiosk and POS equipment that offers the same wealth of services.",
        },
        card4: {
          title: () => "Self-service kiosks",
          youSave1: () => "customer service time",
          youSave2: () => "larger basket",
          description: () =>
            "Increase your business efficiency with our self-service kiosks. They allow for more than you'd expect: they handle your promotions automatically, recommend products, and manage deposits.",
        },
        card5: {
          title: () => "Script-based promotion engine",
          youSave1: () => "larger basket",
          youSave2: () => "attractive promotions",
          youSave3: () => "returning customers - fans of your restaurant",
          description: () =>
            "The innovative _Rapidshop Boosters_ promotion engine, to which you can add your own script, is the answer to Customer expectations in the era of modern sales.\nThanks to engines that we run directly on your POS device, you can fully control the basket and make changes to it depending on the sales situation.\nYou now have a tool to create promotions that will be perfectly tailored to your offer - on par with global quick service brands.",
        },
        card6: {
          title: () => "Product recommendations",
          youSave1: () => "larger basket",
          youSave2: () =>
            "satisfied customers who recommend your venue to others",
          description: () =>
            "Start selling more and smarter with comprehensive product recommendations.\nRecommend the most relevant add-ons to items, also suggest at checkout.\nMotivate your staff to effectively promote basket additions.",
        },
        card7: {
          title: () => "Regular and deferred vouchers",
          youSave1: () => "customer delight",
          youSave2: () => "regularly returning customers",
          description: () =>
            "Your Customer RETURNS to your venue, and you have a larger basket!",
        },
        card8: {
          title: () => "AI built into POS",
          youSave1: () => "time",
          youSave2: () => "better business decisions",
          youSave3: () => "larger basket",
          description: () =>
            "Streamline processes with the first system for hospitality that has built-in AI. From automatically completing product descriptions, through intelligent recommendations, to sales analysis - AI in our POS is your new, indispensable business assistant.",
        },
        card9: {
          title: () => "Loyalty cards built into the system",
          youSave1: () => "customer loyalty",
          youSave2: () => "larger basket",
          youSave3: () => "returning customers",
          description: () =>
            "Build customer loyalty with our built-in NFC loyalty cards.",
        },
        card10: {
          title: () => "Browser application",
          youSave1: () => "relationship with Customer outside your venue",
          youSave2: () => "larger basket",
          youSave3: () => "returning customers",
          description: () =>
            "We know that the real relationship with the Customer starts from the moment they leave your venue. That's why we offer a browser application that allows your Customers to stay in touch with your restaurant. Send push notifications straight to their phones.",
        },
        card11: {
          title: () => "Reputation-protecting surveys",
          youSave1: () => "better position in Google Maps",
          youSave2: () => "new customers",
          youSave3: () => "satisfied customers",
          description: () =>
            "Collect feedback from your Customers and react in real-time without sacrificing your reputation.\nAn internal survey will help you solve problems in case of poor service, and in case of Customer satisfaction - encourage them to leave positive reviews on public platforms.",
        },
        card12: {
          title: () => "Equipment management",
          youSave1: () => "time",
          youSave2: () => "peace of mind",
          youSave3: () => "data security",
          description: () =>
            "A well-thought-out equipment management system with Rapid SafePOS means ease of operation for your employees, and for you - security and stability of your business operations.\nProvisioning new devices is smooth and dynamic - just a few clicks to add a new terminal to your system.",
        },
        card13: {
          title: () => "Dedicated server",
          youSave1: () => "maximum stability",
          youSave2: () => "maximum operating speed",
          description: () =>
            "Rapidshop is a system that already provides exceptional stability and data security in the basic offer. However, if you value maximum stability and operating speed, take advantage of the option to run the Rapidshop system on a server dedicated exclusively to your company.",
        },
        card14: {
          title: () => "Kitchen display system",
          youSave1: () => "time",
          youSave2: () => "fewer mistakes",
          youSave3: () => "no wasted time",
          youSave4: () => "no wasted food",
          description: () =>
            "Optimize your kitchen work with our kitchen display system",
        },
        card15: {
          title: () => "Digital Signage screens",
          youSave1: () => "dynamic menu presentation",
          youSave2: () => "real-time promotions",
          youSave3: () => "professional image",
          description: () =>
            "Digital Signage screens integrated with your POS system display your active menu, promotions, and products in real-time. Capture customer attention with dynamic presentations that automatically adjust to product availability and current promotions.",
        },
        card16: {
          title: () => "Staff Task Screens",
          youSave1: () => "better staff management",
          youSave2: () => "clear task distribution",
          youSave3: () => "increased work efficiency",
          description: () =>
            "Add daily tasks for your team and monitor their completion in real-time. The task screen system allows you to assign independent tasks to staff members, track progress, and maintain a high level of organization in your venue.",
        },
      },
    },
    pricing: {
      title: () => "Pricing",
      subtitle: () => "Choose a plan tailored to your business needs",
      plans: {
        start: {
          title: () => "Start",
          price: () => "99 PLN",
          priceDescription: () => "monthly",
          feature1: () => "1 POS station",
          feature2: () => "Rapidshop Cloud",
          feature3: () => "Sales reports",
          feature4: () => "Technical support",
          feature5: () => "Automatic updates",
          addition: () => "+ Configure system elements as needed",
          cta: () => "Get Started",
        },
        enterprise: {
          title: () => "Enterprise",
          price: () => "On request",
          priceDescription: () => "for large chains",
          feature1: () => "Dedicated server",
          feature2: () => "Unlimited number of stations",
          feature3: () => "Rapidshop AI (kiosk chatbot)",
          feature4: () => "Dedicated account manager",
          feature5: () => "Full system customization",
          feature6: () => "REST API access for all functions",
          feature7: () => "Team training",
          feature8: () => "Custom promotion scripts",
          cta: () => "Contact Us",
        },
      },
    },
  },
  contactAppendix: {
    title: () => "Want to know more?",
    description: () =>
      `Did you know Rapidshop subscriptions start from just <b>3.19 PLN a day</b>? You get a lot for a little!`,
    description2: () =>
      `Leave your <a href="/kontakt">contact</a> to learn more and book a Rapidshop install for your business. We’ll set up a convenient meeting to show you how our solutions drive real profit growth.`,
    cta: () => `Contact us`,
  },
  infoPages: {
    contactForm: {
      title: () => "Start your tech revolution and grow your profits today",
      description: () => `Let’s talk!`,
      enum1: () =>
        `Leave your contact details. Your dedicated advisor will arrange a quick online meeting to demonstrate <strong>how new technology can boost your restaurant’s profits</strong>.`,
      enum2: () =>
        `Want to meet in person? Our office is just steps from Warsaw Central Station. Book a session to test-drive Rapidshop yourself.`,
      enum3: () =>
        `Prefer email? Write to us: <a href="mailto:kontakt@rapidshop.pl">kontakt@rapidshop.pl</a>.`,
    },
    discountSystem: {
      subtitle: () => "Engage, surprise, and inspire loyalty. Boost your sales",
      title: () => "with our promotions and discount system",
      hints: {
        hint1: () => "Print vouchers directly on receipts",
        hint2: () => "Vouchers on the Customer’s screen",
        hint3: () => "Loyalty features",
      },
      sectionTitle: () =>
        "Our promotions & discounts are more than just a sales tool—they’re your secret weapon for building Customer loyalty.",
      description: () =>
        `With our promotions and discounts system, you can surprise Customers with irresistible offers that increase their satisfaction and keep them coming back. Print vouchers right on receipts, highlight offers on the Customer display, and reward loyalty with ease.`,
      comingSoon: () => `Coming soon to Rapidshop!`,
      summary: () =>
        `Do more and delight better<br />
        with the magic of AI in your POS!`,
    },
    cloud: {
      subtitle: () => "Rapidshop Cloud is an intuitive",
      title: () => "cloud-based sales management system",
      hints: {
        hint1: () => "Operational visibility",
        hint2: () => "Access wherever there's internet",
        hint3: () => "Device status control",
      },
      description: () =>
        `Managing your business has never been so simple or effective. Rapidshop Cloud gives you instant access to every detail about your company. <b>Take total control</b> — from product management and transaction tracking to team and device oversight.`,
      subheader1: () => `Easy and powerful product management`,
      subheader1Content: () =>
        `Rapidshop Cloud lets you intuitively manage your product database, add AI-driven tags, and create both basic and complex products. Organize your menu for different sales channels: POS, kiosks, web, or delivery portals.`,
      subheader2: () => `Enhanced sales visibility`,
      subheader2Content: () =>
        `Track every transaction live and generate real-time sales reports. <b>Everything is centralized</b>, no matter which channel it comes from, making performance analysis and business decisions smarter and easier.`,
      subheader3: () => `Employee management`,
      subheader3Content: () =>
        `Assign permissions, review work time summaries, and assign transactions to specific team members. <b>Generate productivity reports</b> to manage and motivate your staff effectively.`,
      subheader4: () => `Device management`,
      subheader4Content: () =>
        `Remotely monitor and control your devices with Rapidshop Cloud. Update menus or block items instantly, regardless of device type.<b>
          Focus on what matters—leave the rest to us.
        </b> Full oversight, wherever you are.`,
      subheader5: () => "Coming soon",
      subheader5Content: () =>
        `New AI tools will make business management smarter than ever. Let artificial intelligence optimize decisions, boost sales, and automate day-to-day work—so you can focus on what matters most.`,
    },
    devices: {
      title: () => "POS Devices",
      subtitle: () => "Fast, lightweight, and designed to boost sales",
      hints: {
        hint1: () => "Android system",
        hint2: () => "Simple and energy-saving",
        hint3: () => "Integrated with readers & printers",
      },
      title2: () => "New ways to sell",
      description: () =>
        `The POS market has seen a real revolution. Today’s POS devices are more than just computers—they’re multimedia workhorses that don’t just ring up sales, they build Customer relationships. <b>At Rapidshop, we harness the power of modern POS devices to drive your sales.</b>`,
      devices: {
        hint1: () => "NFC Readers",
        hint2: () => "Customer Cards",
        hint3: () => "QR Scanners",
        hint4: () => "E-Receipts",
      },
      summary: () => `Do more and serve better<br />
        with the magic of AI in your POS!`,
    },
    kds: {
      subtitle: () => "Modern and Integrated",
      title: () => "KDS Application",
      hints: {
        hint1: () => "Full control over order status",
        hint2: () => "Print individual items",
      },
      description: () =>
        `<h2>
            KDS puts you in command of your kitchen, so waitstaff always know what’s next and when.
          </h2>
          <p>
            More than just convenience—our KDS boosts sales and Customer satisfaction. Ergonomic design and intuitive interface keep chefs updated and orders moving, leading to speedier service and higher turnover.
          </p>
          <p>
            With our touchscreen KDS, waitstaff can print orders directly to the kitchen printer. <b>No more lost tickets—Customers always get exactly what they’re waiting for.</b>
          </p>
          <p>
            Add a <b>Number Display</b> to your KDS. Staff can update order statuses for Customers and announce pickups, streamlining the kitchen and pickup process even further.
          </p>
          <p>
            Soon, even more AI-driven Rapidshop tools will arrive in KDS to supercharge your kitchen’s workflow.
          </p>`,
      summary: () =>
        `Invest in new technology<br /> and grow your sales by optimizing operations!`,
    },
    rapidshopAI: {
      subtitle: () => "AI Magic for Your Restaurant",
      title: () => "Rapidshop AI",
      description1Title: () => `
        Do more, serve better.<br />Unleash the magic of artificial intelligence at your point of sale!
      `,
      description1: () =>
        `Bring artificial intelligence into your POS system to 
          <b>boost efficiency and deliver next-level customer service</b>. Rapidshop AI is an innovative solution that leverages the latest advances in AI to help your restaurant reach new heights. With Rapidshop AI, you can automate countless tasks, saving you both time and money.`,
      features: {
        titles: {
          title: () =>
            "AI-powered product name and description generation & translation",
          description: () =>
            `Rapidshop AI automatically generates and translates product names and descriptions in your POS system. Effortlessly customize your menu for guests from any country, increasing their satisfaction and loyalty—without hiring extra staff.`,
        },
        aiAgents: {
          title: () => `AI Voice Assistants in Self-service Kiosks`,
          description: () =>
            `Rapidshop AI also powers smart AI agents that can be installed in your self-service kiosks. These agents guide customers through ordering food and drinks, providing product and promo info instantly. Available 24/7—with limitless patience—your kiosks are always ready to serve customers, any time of day or night.`,
        },
      },
    },
    aiKiosk: {
      subtitle: () => "Meet our breakthrough",
      title: () => "Self-service kiosks",
      hints: {
        hint1: () => "Powered by artificial intelligence",
        hint2: () => "Sleek design and refined UI",
        hint3: () => "Engineered for higher sales",
      },
      description1: () =>
        `Self-service kiosks are a true game-changer today. For you, they’re a chance to boost revenue!`,
      description2: () =>
        `It's your opportunity to reach new Customers, offering your products the moment they want them.`,
      description3: () =>
        `Bigger orders, thanks to better recommendations and clear offers.`,
      description4: () =>
        `Our elegant kiosk: modern design, functionality and simplicity—all perfectly suited to any retail space. Place it on a premium stand, or blend it into your counter. Customers love the convenience and the way our intelligent onscreen suggestions inspire them to try more.`,
      description5: () =>
        `Our kiosks are smoother, faster, and give Customers even more choices.`,
      description6: () =>
        `Owning a kiosk is easy. Making it truly great is the trick! A successful kiosk is all about stellar Customer experience. In today’s tech-savvy world, people expect a smooth, user-friendly interface.<b>Rapidshop kiosks deliver just that.</b> Simple navigation helps Customers find what they need, boosting satisfaction and encouraging them to return. <b>And with intuitive upselling features built in</b>, it’s an effortless way to increase revenue.`,
      description7: () => `
        But user interface is just one piece of the puzzle. True UX is crafted from smart design, clear architecture, effortless navigation, and fast performance—every detail that makes your Customer’s experience a delight.
      `,
      description8: () =>
        `When people enjoy using your kiosk, they’ll come back! <b>Effortless, enjoyable experiences spark positive emotions</b>—and emotions forge brand loyalty. Invest in great UX to secure the future for your business and Customers.`,
      aiSection: {
        title: () =>
          `Just like your phone. Tap, speak…<span style="fontSize: "1.3em">and done!</span><br /> Now imagine your kiosk was that smart!`,
        description: () => `<strong>
                    No more limitations. Let your Customers talk to your kiosk—boosting both engagement and sales!
                  </strong>
        
                  <p>
                    Kiosk with AI isn’t just a modern device, it’s an entirely new experience for your business. AI lets your kiosk <b>interact proactively</b> with your Customers.
                  </p>
                  <p>
                    AI-powered voice assistant helps you reach more people than any traditional kiosk. Advanced language models make communication easy for everyone—unlock new audiences who previously avoided self-service tech.
                  </p>
        `,
      },
      languageBarrierSection: {
        title: () => `Break the language barrier and stand out <br />
            with exceptional tourist service in your venue!`,
        description: () =>
          `<p>
            In a tourist hotspot or multilingual city? Or serve Customers who aren’t confident in Polish? AI-powered kiosks are the ultimate solution—enabling hassle-free communication for everyone. The voice assistant lets all Customers order, learn about products, and find deals in their language—increasing both sales and satisfaction.
          </p>
          <p>
            No need to enter multi-language descriptions manually—our AI voice assistant <b>instantly translates information</b> on demand for smooth, problem-free communication.<b>Deliver exceptional service, even if your staff don’t speak your Customers’ language</b>—unlocking business from entirely new groups.
          </p>`,
      },
      safeposSection: {
        title: () =>
          `Rapid SAFEPOS – Predictability & Cybersecurity for Kiosks`,
        description: () => `
          <p>
            The best kiosk is one that just works. <b>
              Every self-service device needs proper management so it stays reliable and safe.
            </b>
            That’s why we pre-install “Rapid SAFEPOS” on every device we ship. You get full confidence your business <b>runs like a well‑oiled machine.</b>
          </p>
          <p>
            <a href="/latwe-zarzadzanie-sprzetem">
              More about Rapid SAFEPOS &gt;
            </a>
          </p>`,
      },
    },
    posApp: {
      subtitle: () => "Ergonomic, user-friendly, and fully mobile",
      title: () => "Sales Application",
      hints: {
        hint1: () => "On your countertop device",
        hint2: () => "In your hand, on the go",
        hint3: () => "Your command center, from anywhere",
      },
      descriptionTitle: () =>
        `Our POS app works seamlessly—whether on the counter or in your cashier’s hand. No more running to the bar!`,
      description: () =>
        `<p>
          Now your team can work efficiently and confusion-free. Our state-of-the-art POS app not only streamlines daily operations but is your key to increasing sales and Customer satisfaction.
        </p>
        <p>
          The ergonomic design and intuitive interface allow your staff to process orders in a flash. This leads directly to positive Customer experiences and a clear boost in revenue.
        </p>
        <h2>
          Use the Customer Display to build loyalty and connection
        </h2>
        <p>
          The Customer Display is so much more than just a bill preview. Let your team impress by showing personalized offers, promos, and product info. Inspire extra purchases and keep Customers coming back with unique experiences.
        </p>
        <h2>Fiscal Control & Payments</h2>
        <p>
          Fiscalize open bills right from the app with supported fiscal printers (currently POSNET). Payment and card processing is handled by <b>eservice</b>—our trusted partner and a market leader for stability and reliability.
        </p>`,
      summary: () =>
        `Do more and serve better<br />with the magic of AI in your POS!`,
    },
    safePOS: {
      subtitle: () => "Rapid SAFE POS – finally,",
      title: () => "Effortless Device Management",
      hints: {
        hint1: () => "Fewer unexpected breakdowns",
        hint2: () => "Greater security",
        hint3: () => "Full device oversight",
      },
      description: () => `
      <p>
          Managing hardware can be a challenge, but "Rapid SAFE POS" makes it magically easy.
          <b>
            Like a magic wand, it turns hard into easy and complicated into simple.
          </b>
          Owners don’t need to stress over technical headaches or worry about breakdowns. "Rapid SAFE POS" gives you full control of your equipment so you can focus on delighting Customers and growing your business.
        </p>
        <p>
          One major benefit: <b>
            staff and Customers only have access to what’s needed for their work.
          </b>
          This means no accidental setting changes or dangerous tweaks—drastically reducing the need for technical support.
        </p>
        <p>
          "Rapid SAFE POS" keeps you updated on device status in real time, regardless of model. Get rapid-response troubleshooting and one-click software updates. Need a new feature for your kiosk? It’s delivered in seconds—making the whole system more secure and easier to manage.
        </p>
        <p>
          The result? <b>Lower staff training costs.</b> Thanks to the simplified interface and limited actions, onboarding new team members is a breeze. Save time and money—freeing you to focus on business growth. Your kiosks will run more reliably, ensuring a stable operation so you can build your company.
        </p>`,
    },
    pricing: {
      subtitle: () => "Choosing Rapidshop means investing in your future",
      title: () => "Unlock modern sales technology",
      benefits: {
        incomes: () => `
            <h2>Increase Profits</h2>
            <p>
              Save time and money. Our system helps you cut unnecessary costs through inventory optimization and minimizes human error in order processing and payments.
            </p>`,
        simplicity: () => `
            <h2>Effortless to use—and easy to love</h2>
            <p>
              Thanks to an intuitive interface, your staff become experts in minutes, not hours—so you can focus on delivering top-notch Customer service.
            </p>`,
        realtime: () => `
            <h2>Real-time data at your fingertips</h2>
            <p>
              Make confident decisions with instant-access sales reports, Customer trends, and team performance analytics. Stay ahead of the competition, knowing what works best for your business.
            </p>`,
        lessBreakdowns: () => `
            <h2>Less downtime, more peace of mind</h2>
            <p>
              Our POS system features lower maintenance costs thanks to modern, affordable hardware. Every device is built for long-lasting performance—meaning less disruption and more satisfaction for your team.
            </p>`,
      },
      suitableForYou: () => `
      <h1>Finally—tailored for you</h1>
        <p>
          Our flexible pricing plans are designed for businesses of every size. Streamline operations and take your restaurant to the next level.
          <br />
          <strong>
            Leave us your contact and let’s discuss the perfect implementation plan for you!
          </strong>
        </p>`,
      minimalPlan: () => `
        net per month – that’s where our subscription plans begin. Even the basic package gives you so much!<div>Write to us to learn more.</div>`,
    },
  },
  contactForm: {
    cta: () => "Click here and proceed to contact form",
    orderNow: () => "Order now",
  },
};

export default locale;
